import type { MigratedCredentials } from '@entities/user';

import type { MemUserRepository } from '@infra/repositories/mem-user.repository';

import { RepositoryFactory } from '@main/factories/repository.factory';
import type { HttpClientOptions } from '@main/http/http-client';
import { HttpClient } from '@main/http/http-client';

export type UpdateTokens = {
  idToken: string;
  refreshToken: string;
};

export class IdHttpClient extends HttpClient {
  private static host = process.env.HOST;
  private static baseURL = `https://id.${this.host}`;
  private static options: HttpClientOptions = {
    baseUrl: this.baseURL,
  };
  private static ssoLogoutUrl = '';

  private userRepository: MemUserRepository;

  constructor() {
    super(IdHttpClient.options);

    this.userRepository = RepositoryFactory.buildMemUserRepository();
  }

  async updateToken() {
    const user = this.userRepository.user;

    if (user) {
      const { refreshToken } = <MigratedCredentials>user.credentials;
      const tokens = await this.get<UpdateTokens>('/auth/v1/tokens/refresh', {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
          'Aircall-Platform': 'salesforce',
        },
      });

      this.userRepository.updateTokens(tokens);
    }
  }

  async fetchSsoIdpCallback(email: string) {
    const samlIdpEnpoint = process.env.SAML_IDP;
    let result;
    try {
      result = await this.post<{ url: string; logoutUrl: string }>(
        samlIdpEnpoint,
        { email },
        {
          headers: {
            'Aircall-Platform': 'salesforce',
          },
        },
      );
    } catch (e) {
      console.log(e);
    }
    return result;
  }

  set ssoLogoutUrl(url: string) {
    IdHttpClient.ssoLogoutUrl = url;
  }
}

export const idHttpClient = new IdHttpClient();
